import Vue from 'vue'

export default function (pluginsHandler) {
    return {
        name: 'checkbox',
        treeMixins: {
            props: {
                checkboxChildCheckParents: {
                    type: Boolean,
                    default: false
                },
                checkboxPartselPresentation: {
                    type: Boolean,
                    default: false
                },
                checkboxParentCheckChildren: {
                    type: Boolean,
                    default: false
                },
                checkboxButtonCheckUncheckAll: {
                    type: Boolean,
                    default: false
                },
                checkboxCheckedItems: {
                    type: Array,
                    default: () => {
                        return []
                    }
                }
            },
            data() {
                return {
                    checkboxIsCheckAll: true
                }
            },
            methods: {
                checkboxCheckSelected(checkedItems) {
                    let itemsRefsToSelect = this.defaultFindElementsByIDs(checkedItems)

                    itemsRefsToSelect.forEach(item => {
                        this.checkboxSelectItem(item, true)
                    })
                },
                checkboxCheckAll(startEl, checked = true) {
                    startEl.$children.forEach(child => {
                        if (child.rowItem && child.rowItem.internal) {
                            if (!!child.searchIsVisible || typeof child.searchIsVisible === 'undefined')
                                Vue.set(child.rowItem.internal, 'checkbox-checked', checked)

                            if (this.checkboxPartselPresentation)
                                child.checkboxPartselStatus = false
                        }

                        if (child.$children && child.$children.length) {
                            this.checkboxCheckAll(child, checked)
                        }
                    })
                },
                checkboxUncheckAll(startEl) {
                    this.checkboxCheckAll(startEl, false)
                },
                checkboxCheckUncheckAll() {
                    if (this.checkboxIsCheckAll) {
                        this.checkboxCheckAll(this)
                    } else {
                        this.checkboxUncheckAll(this)
                    }

                    this.checkboxIsCheckAll = !this.checkboxIsCheckAll
                },
                checkboxHasCheckedItems(startEl) {
                    return Boolean(this._checkboxGetCheckedItems(startEl).checkedItems.length)
                },
                _checkboxGetCheckedItems(startEl) {
                    let checkedItems = []
                    var count = 0

                    function findCheckedItems(el) {
                        el.$children.forEach((child) => {
                            if (child.rowItem) {
                                if (child.rowItem.internal['checkbox-checked']) {
                                    checkedItems.push(child)
                                }
                                count++
                            }

                            if (child.$children && child.$children.length) {
                                findCheckedItems(child)
                            }
                        })
                    }

                    findCheckedItems(startEl)

                    return {
                        countAll: count,
                        checkedItems: checkedItems
                    }
                },
                checkboxGetCheckedItems(onlyLeafs = false, flat = false, data = this.data) {
                    let result = []

                    const pathToChecked = function (data, parent = null) {
                        let isFound = false
                        data.forEach((item) => {

                            if (item.internal['checkbox-checked'] && !onlyLeafs) {
                                isFound = true
                                // child
                                let tmpTreeItem = Object.assign({}, item, {
                                    parent: parent
                                })
                                delete tmpTreeItem[this.defaultSubItemsKey]

                                result.push(tmpTreeItem)
                            }

                            if (item.internal['checkbox-checked'] && onlyLeafs) {
                                if (!!!item[this.defaultSubItemsKey] || !!!item[this.defaultSubItemsKey].length) {
                                    result.push(item)
                                }
                            }

                            if (item[this.defaultSubItemsKey] && item[this.defaultSubItemsKey].length) {
                                let hasFound = pathToChecked(item.children, item.internal['_id'])

                                if (hasFound && !onlyLeafs) {
                                    if (!!!result.find((stroredItem) => {
                                        return stroredItem.internal['_id'] === item.internal['_id'] //[this.defaultPropertyIdKey]
                                    })) {
                                        let tmpTreeItem = Object.assign({}, item, {
                                            parent: parent
                                        })

                                        delete tmpTreeItem[this.defaultSubItemsKey]

                                        result.push(tmpTreeItem)
                                    }
                                }

                                if (hasFound) {
                                    isFound = true
                                }
                            }
                        })

                        return isFound
                    }.bind(this)

                    pathToChecked(data)

                    if (flat || onlyLeafs) {
                        return result
                    } else {
                        result.sort((a, b) => {
                            return b.parent - a.parent
                        })

                        result.forEach((child, index) => {
                            if (Object.keys(child).length) {
                                result.find((parent) => {
                                    if (parent.internal && parent.internal['_id'] === child.parent) {
                                        if (typeof parent.children === 'undefined') {
                                            parent[this.defaultSubItemsKey] = []
                                        }
                                        delete child.parent
                                        parent[this.defaultSubItemsKey].push(child)
                                        result[index] = {}

                                        return true
                                    }
                                })

                                delete child.parent
                            }
                        })

                        return result.filter(item => {
                            return Object.keys(item).length
                        })
                    }
                },
                checkboxIsAllChecked(startEl) {
                    let tmpInfo = this._checkboxGetCheckedItems(startEl)

                    return tmpInfo.countAll === tmpInfo.checkedItems.length
                },
                checkboxChildCheckParent(startEl, checkStatus) {
                    while (startEl.constructor.options.name === 'oc-tree-item') {
                        if (startEl.rowItem && startEl.isFolder) {
                            if (checkStatus) {
                                if (this.checkboxPartselPresentation) {
                                    if (this.checkboxIsAllChecked(startEl)) {
                                        Vue.set(startEl.rowItem.internal, 'checkbox-checked', checkStatus)
                                        startEl.checkboxPartselStatus = false
                                    } else {
                                        startEl.checkboxPartselStatus = true
                                    }
                                } else {
                                    Vue.set(startEl.rowItem.internal, 'checkbox-checked', checkStatus)
                                }
                            } else {
                                let hasCheckedChildren = this.checkboxHasCheckedItems(startEl)

                                if (!hasCheckedChildren) {
                                    startEl.checkboxPartselStatus = false
                                    Vue.set(startEl.rowItem.internal, 'checkbox-checked', checkStatus)

                                }

                                if (this.checkboxPartselPresentation && hasCheckedChildren) {
                                    startEl.checkboxPartselStatus = true
                                    Vue.set(startEl.rowItem.internal, 'checkbox-checked', checkStatus)
                                }
                            }
                        }

                        return this.checkboxChildCheckParent(startEl.$parent, checkStatus)
                    }
                },
                checkboxSelectItem(item, status) {
                    //check current element
                    Vue.set(item.rowItem.internal, 'checkbox-checked', status)

                    if (this.checkboxParentCheckChildren) {
                        this.checkboxCheckAll(item, status)
                    }
                    if (this.checkboxChildCheckParents) {
                        this.checkboxChildCheckParent(item, status)
                    }

                    //emit event with element that will be un/checked and its new status
                    this.eventBus.$emit('checkbox:changeStatus', item, status)
                }
            },
            mounted() {
                this.checkboxCheckSelected(this.checkboxCheckedItems)
            },
            computed: {
                checkboxHasSearch() {
                    return !!this.search && !!this.search.length
                }
            }
        },
        treeRowMixins: {
            methods: {
                checkboxSelect(status) {
                    this.treeObject.checkboxSelectItem(this, status)
                }
            },
            data() {
                return {
                    checkboxPartselStatus: false
                }
            },
            mounted() {
                //set partsel state of checkboxes
                if (this.isFolder) {
                    if (!this.treeObject.checkboxIsAllChecked(this))
                        this.checkboxPartselStatus == true
                }

                this.$refs.checkbox.$on('input', (status) => {
                    this.checkboxSelect(!status)
                })

            }
        },
        slotsContent: {
            beforeTree: `<oc-button-input v-if="checkboxButtonCheckUncheckAll && !checkboxHasSearch" @click="checkboxCheckUncheckAll" class="btn btn-sm btn-info oc-tree-checkbox-button-all">{{checkboxIsCheckAll ? 'Check' : 'Uncheck'}} All</oc-button-input>`,
            rowPrepend: `<span @click="$refs.checkbox.$emit('input', rowItem.internal['checkbox-checked'])" class="checkbox oc-tree-checkbox-input" :class="{'partsel': treeObject.checkboxPartselPresentation && checkboxPartselStatus, checked: rowItem.internal['checkbox-checked']}">
                            <oc-checkbox-input ref="checkbox" v-model="rowItem.internal['checkbox-checked']" />
                         </span>`
        },
        processData(data, tree) {
            function appendData(source) {
                Object.keys(source).forEach((key) => {
                    Vue.set(source[key].internal, 'checkbox-checked', false)

                    if (source[key].children) {
                        appendData(source[key].children)
                    }
                })

                return data;
            }
            appendData(data);
            return data;
        }
    }
}
